import { render, staticRenderFns } from "./demand.vue?vue&type=template&id=130dbbfc&scoped=true&"
import script from "./demand.vue?vue&type=script&lang=js&"
export * from "./demand.vue?vue&type=script&lang=js&"
import style0 from "./demand.vue?vue&type=style&index=0&id=130dbbfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130dbbfc",
  null
  
)

export default component.exports